<template>
  <section>
    <h1 class="section-head">เพิ่มคำสั่งซื้อ</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <router-link class="button is-danger is-pulled-left" :to="backPage"> <i class="fas fa-arrow-left"> </i> Back</router-link>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <button class="button is-success is-pulled-right" :class="loadingClass" @click="submit"><i class="fas fa-clipboard-list"></i>บันทึก</button>
          </div>
        </div>
      </div>
    </nav>

    <div class="margin-botton-10">
      <h1 class="section-sub-head">รายละเอียดลูกค้า</h1>
    </div>

    <div class="columns">
      <div class="column">
        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">Company</label>
              <b-autocomplete
                v-model="order.company"
                placeholder="ชื่อลูกค้า/บริษัท"
                :clear-on-select="false"
                :keep-first="true"
                :open-on-focus="true"
                :data="filteredCustomerObj"
                field="name"
                @select="selectedCustomer"
                :disabled="customerList.length < 1"
              >
              </b-autocomplete>
            </div>
            <div class="field"></div>
          </div>
        </div>
        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">Address</label>
              <b-input v-model="order.address" placeholder="Address"></b-input>
            </div>
          </div>
        </div>
        <h3 class="section-sub-head">รายละเอียดคำสั่งซื้อ</h3>
        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">PO Number</label>
              <b-input v-model="order.po_number" placeholder="PO Number"></b-input>
            </div>
            <div class="field"></div>
            <div class="field"></div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">Phone</label>
              <b-input v-model="order.phone" placeholder="Phone"></b-input>
            </div>
            <div class="field">
              <label class="label">E-Mail</label>
              <b-input v-model="order.email" placeholder="E-Mail"></b-input>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">Fax</label>
              <b-input v-model="order.fax" placeholder="Fax."></b-input>
            </div>
            <div class="field">
              <label class="label">Tax No.</label>
              <b-input v-model="order.tax_no" placeholder="Tax No."></b-input>
            </div>
          </div>
        </div>

        <div class="column has-background-gray" v-if="!order.id">
          <h3 class="section-sub-head">ข้อมูลสำหรับ Invoice เก่า</h3>
          <div class="field">
            <div class="field-body">
              <div class="field">
                <label class="label">เลขที่ Invoice เดิม (Ex. ECO2018-0001)</label>
                <b-input v-model="order.ship_code" placeholder="เลขที่ Invoice เดิม"></b-input>
              </div>
              <div class="field">
                <b-field label="วันที่จัดส่งเดิม">
                  <div class="field">
                    <b-datepicker placeholder="วันที่จัดส่งเดิม" icon-pack="fa" icon="calendar" v-model="order.ship_date" :date-formatter="dateFormatter"> </b-datepicker>
                  </div>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="margin-botton-10 section-sub-head columns">
      <h1 class="column">รายการสินค้า</h1>
      <div class="column">
        <div class="field has-addons has-addons-right">
          <div class="control">
            <b-input placeholder="Search..." v-model="search_query" type="search" icon="search" icon-pack="fas" width="250"></b-input>
          </div>
          <div class="control">
            <button class="button" @click="init">Refresh</button>
          </div>
        </div>
      </div>
    </div>

    <div>
      <b-table
        :data="filteredData"
        :hoverable="true"
        :loading="isLoading"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :narrowed="true"
        v-if="products.length > 0 && !isLoading"
        class="table-style"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="#" width="30"> #{{ props.row.id }}<br /> </b-table-column>
          <b-table-column field="name" label="ชื่อผลิตภัณฑ์" width="200"> {{ props.row.name }} <br /> </b-table-column>

          <b-table-column field="sup_name" label="Supplier" width="150">
            <span class="has-text-grey">{{ props.row.sup_name }}</span>
          </b-table-column>

          <b-table-column field="in_stock" label="คงเหลือ" width="50"> {{ parseFloat(props.row.in_stock).formatMoney(2) }} {{ props.row.unit_sell_text }} </b-table-column>

          <b-table-column field="price_sell" label="ราคาขาย" width="100">
            {{ parseFloat(order.cus_type == 'pestguard' || order.type == 'pestguard' ? props.row.price_sell : props.row.general_price_sell).formatMoney(2) }} บาท/{{ props.row.unit_sell_text }}
          </b-table-column>

          <b-table-column label="ส่วนลด(%)" width="60">
            <div class="field has-addons">
              <p class="control">
                <b-input size="is-small" placeholder="ส่วนลด %" v-model="discount[props.row.id]"></b-input>
              </p>
            </div>
          </b-table-column>

          <b-table-column label="ส่วนลด(฿)" width="60">
            <div class="field has-addons">
              <p class="control">
                <b-input size="is-small" placeholder="ส่วนลด ฿" v-model="discount_baht[props.row.id]"></b-input>
              </p>
            </div>
          </b-table-column>

          <b-table-column field="price_sell" label="จำนวนสั่ง" width="60">
            <div class="field has-addons">
              <p class="control">
                <b-input size="is-small" placeholder="จำนวนสั่ง" v-model="amount[props.row.id]"></b-input>
              </p>
              <p class="control">
                <button class="button is-static is-small">
                  {{ props.row.unit_sell_text }}
                </button>
              </p>
            </div>
          </b-table-column>

          <b-table-column field="name" label="รวม" width="100">
            {{
              parseFloat(
                amount[props.row.id]
                  ? amount[props.row.id] * (order.type == 'pestguard' ? props.row.price_sell : props.row.general_price_sell) -
                      amount[props.row.id] * (order.type == 'pestguard' ? props.row.price_sell : props.row.general_price_sell) * ((discount[props.row.id] ? discount[props.row.id] : 0) / 100) -
                      (discount_baht[props.row.id] ? discount_baht[props.row.id] : 0)
                  : 0
              ).formatMoney(2)
            }}
            บาท
          </b-table-column>

          <b-table-column field="remark" label="Remark" width="250">
            <div class="field">
              <p class="control">
                <b-input size="is-small" placeholder="Remark" v-model="remark[props.row.id]"></b-input>
              </p>
            </div>
          </b-table-column>
        </template>
      </b-table>

      <div class="notification has-text-centered" v-else>ไม่มีรายการผลิตภัณฑ์</div>
    </div>
  </section>
</template>

<script>
import Request from '@/libraries/request';
import ProductModel from '@/model/product_model';
import SupplierModel from '@/model/supplier_model';
import CustomerModel from '@/model/customer_model';
import OrderModel from '@/model/order_model';
import Const from '@/const/const';
import moment from 'moment';

export default {
  data() {
    return {
      order: {
        company: '',
      },
      products: [],
      customerList: [],
      discount: [],
      discount_baht: [],
      amount: [],
      total: [],
      remark: [],
      isLoading: true,
      loadingClass: '',
      backPage: '/order',

      isPaginated: true,
      isPaginationSimple: false,
      currentPage: 1,
      perPage: 20,
      search_query: '',
    };
  },
  mounted() {
    this.isLoading = true;
    this.init();
  },
  computed: {
    filteredCustomerObj() {
      return this.customerList.filter(option => {
        if (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.order.company.toLowerCase()) >= 0
        ) {
          return option;
        } else {
          return false;
        }
      });
    },
    filteredData: function() {
      return this.products.filter(product => {
        return product.name && product.name.toLowerCase().includes(this.search_query.toLowerCase());
      });
    },
  },
  methods: {
    async init() {
      this.isLoading = true;
      this.customerList = await CustomerModel.get_all_customer();
      try {
        if (this.$route.params.id) {
          const order = await OrderModel.get_order(this.$route.params.id);
          this.order = order[0];
          if (typeof this.order.ship_date !== 'undefined') {
            this.order.ship_date = moment(this.order.ship_date).toDate();
          }
          let amount = [];
          let discount = [];
          let discount_baht = [];
          let total = [];
          let remark = [];
          for (const [key, item] of Object.entries(this.order.items)) {
            amount[item.pro_id] = item.amount;
            discount[item.pro_id] = item.discount;
            discount_baht[item.pro_id] = item.discount_baht;
            remark[item.pro_id] = item.remark;
          }
          this.amount = amount;
          this.discount = discount;
          this.discount_baht = discount_baht;
          this.remark = remark;
          this.backPage = '/order/view/' + this.$route.params.id;
        }
        this.products = await ProductModel.get_all_product();
      } catch (e) {
        this.$buefy.snackbar.open(e.message);
        this.$router.push('/order');
      }
      this.isLoading = false;
    },
    selectedCustomer(customer) {
      if (customer == null) {
        return;
      }
      this.order.cus_id = customer.id || 0;
      this.order.company = customer.name;
      this.order.address = customer.address;
      this.order.phone = customer.phone;
      this.order.email = customer.email;
      this.order.fax = customer.fax;
      this.order.tax_no = customer.tax_no;
      this.order.type = customer.type;
    },
    dateFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    submit() {
      this.loadingClass = 'is-loading';
      this.isLoading = true;

      if (this.order.company == '') {
        this.$buefy.snackbar.open('โปรดเลือกรายการลูกค้า');
        this.isLoading = false;
        this.loadingClass = '';
        return;
      }

      var data = Object.assign({}, this.order);
      data.items = [];
      if (this.$route.params.id) {
        data.id = this.$route.params.id;
      }

      if (this.amount == undefined || this.amount.length < 1) {
        this.$buefy.snackbar.open('ไม่มีการใส่จำนวนในรายการสิ้นค้าใด');
        this.isLoading = false;
        this.loadingClass = '';
        return;
      }

      for (const [key, value] of Object.entries(this.amount)) {
        let item = {};
        item.id = key;
        item.amount = value;
        item.discount = this.discount[key] ? this.discount[key] : 0;
        item.discount_baht = this.discount_baht[key] ? this.discount_baht[key] : 0;
        item.remark = this.remark[key] ? this.remark[key] : '';
        data.items.push(item);
      }
      if (!!data.ship_date) {
        data.ship_date = moment(data.ship_date).format('YYYY-MM-DD 00:00:00');
      }

      if (!!data.ship_code && !data.id) {
        let dateSplit = data.ship_code.split('-');
        dateSplit[0] = dateSplit[0].split('ECO');
        data.ship_code_id = dateSplit[1];
        data.ship_year = dateSplit[0][1];
        data.ship_status = 1;
      }

      Request.post(
        'order/add',
        data,
        res => {
          this.isLoading = false;
          this.loadingClass = '';
          if (res.data.status) {
            if (res.data.data.id) {
              this.$buefy.snackbar.open('บันทึกสำเร็จ!');
              this.$router.push({ path: '/order/view/' + res.data.data.id });
            } else {
              this.$router.push({ path: '/order' });
            }
          } else {
            this.$buefy.snackbar.open('มีข้อผิดผลาด [ORDERADD:377]!');
            this.$router.push({ path: '/order' });
          }
        },
        error => {
          this.$buefy.snackbar.open('มีข้อผิดผลาด [ORDERADD:382]!');
          this.$router.push({ path: '/order' });
        }
      );
    },
  },
};
</script>

<style scoped>
.table-style {
  font-size: 0.8rem;
}

.has-background-gray {
  background-color: #e7e7e7;
}
</style>



// WEBPACK FOOTER //
// src/pages/Order/add.vue